import React from 'react';
import { Control } from 'react-hook-form';
import { BuslineDetailQueryResponse } from '@area-restrita/api-client/model/buslineDetailQueryResponse';

import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Icons } from '@/components/icons';

import BuslineForm, { IBuslineSchema } from '../../components/BuslineForm';
import RoutePreview from './route-preview';

interface IProps {
  busline: BuslineDetailQueryResponse;
  control: Control<IBuslineSchema>;
  isLoading: boolean;
  isDirty: boolean;
  onSubmit: () => void;
  onReset: () => void;
}

const BuslineGeneralView: React.FC<IProps> = ({
  busline,
  control,
  isLoading,
  isDirty,
  onReset,
  onSubmit,
}) => (
  <div className="flex flex-col xl:flex-row flex-wrap gap-6">
    <Card className="flex-1 min-w-[450px]">
      <CardHeader>
        <CardTitle>Informações Gerais</CardTitle>
        <CardDescription>Informações sobre a linha de ônibus.</CardDescription>
      </CardHeader>

      <CardContent>
        <BuslineForm control={control} isLoading={isLoading} />
      </CardContent>
      <CardFooter className="flex justify-end border-t px-6 py-4 gap-4">
        <Button variant="outline" disabled={!isDirty} onClick={onReset}>
          Resetar
        </Button>

        <Button
          type="submit"
          disabled={isLoading || !isDirty}
          onClick={onSubmit}
        >
          {isLoading && <Icons.spinner className="mr-2 h-4 w-4 animate-spin" />}
          Salvar
        </Button>
      </CardFooter>
    </Card>
    <RoutePreview control={control} busline={busline} />
  </div>
);

export default BuslineGeneralView;
